import { Phone } from "lucide-react";
import { PageHero } from "@/components/Blocks";
import ConsultationForm from "@/components/ConsultationForm";
import { Reveal } from "@/components/motion";
import { CONTACT } from "@/data/content";

const STEPS = [
  { n: "01", t: "Reach us", d: "Call the triage line or send the form below, marked as immediate support." },
  { n: "02", t: "Rapid assessment", d: "We respond as a priority to understand what has happened and what you need." },
  { n: "03", t: "Acute intervention", d: "Same-day or acute intervention within hours or days — online or in person." },
];

export default function ImmediateSupport() {
  return (
    <main data-testid="immediate-support-page">
      <PageHero
        urgent
        testId="immediate-support-hero"
        eyebrow="Immediate post-trauma service"
        lines={["PTS, not PTSD.", "Act in the hours", "that matter."]}
        intro="For acute post-incident trauma requiring immediate intervention. Our service is focused on same-day or acute intervention within hours or days to stop PTSD before it develops."
      />
      <section className="bg-[#070A12] pb-10">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
          <Reveal>
            <a href="#urgent-form" data-testid="pts-triage-hotline-button" className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border border-red-400/30 bg-red-500/10 px-7 py-6 hover:bg-red-500/15 transition-colors duration-300">
              <span className="flex items-center gap-4 text-slate-100"><Phone className="w-5 h-5 text-red-300" /> Triage line</span>
              <span className="font-data text-lg text-red-200">{CONTACT.triage}</span>
            </a>
          </Reveal>
          <div className="mt-16 grid md:grid-cols-3 gap-px bg-white/10">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1} className="bg-[#070A12] p-8 sm:p-10" data-testid={`pts-step-${i + 1}`}>
                <span className="font-data text-xs text-red-300">{s.n}</span>
                <h3 className="font-display text-3xl text-slate-50 mt-4">{s.t}</h3>
                <p className="mt-4 text-sm text-slate-300 leading-relaxed">{s.d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section id="urgent-form" className="bg-[#070A12] py-24">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8 lg:px-12">
          <p className="eyebrow mb-4">Immediate support request</p>
          <h2 className="font-display text-4xl sm:text-5xl text-slate-50 mb-12">Tell us when we can speak.</h2>
          <ConsultationForm defaultUrgent />
        </div>
      </section>
    </main>
  );
}
